import { useMutation, useQueryClient } from "@tanstack/react-query";

import { showErrorToast } from "#app/notifications";
import { companyQuery } from "#modules/company/infra/company.query";
import { replayOnboarding } from "#modules/company/infra/replayOnboarding.api";

export type UseReplayOnboardingOptions = {
  onSuccess?: () => void | Promise<void>;
};

export const useReplayOnboarding = ({ onSuccess }: UseReplayOnboardingOptions = {}) => {
  const queryClient = useQueryClient();

  const { mutate, ...rest } = useMutation({
    mutationFn: replayOnboarding,
    onSuccess: async () => {
      await queryClient.invalidateQueries(companyQuery());
      await onSuccess?.();
    },
    onError: (err: Error) => showErrorToast({ title: err.message }),
  });

  return { replayOnboarding: mutate, ...rest };
};
